export default __webpack_public_path__ + "static/media/ODEImg8.78bbc3cc.PNG";